import React, { useEffect, useRef } from "react";
import { useRouter } from "next/router";
import Slider from "react-slick";
import styled from "styled-components";

import { Box, FlexContainer, FlexDiv, Button } from "@/components/Atoms";

import { Typography } from "@/foundation/Typography/V1";
import theme from "@/foundation/Theme";

const CardComponent = (props) => {
  const router = useRouter();
  const { cardRef, isNutritionPage } = props || {};
  const slider = useRef(null);
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 4,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 3.15,
          dots: true,
          infinite: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.15,
          slidesToScroll: 1,
          dots: false,
          infinite: false,
        },
      },
    ],
  };
  useEffect(() => {
    let sliders = slider;
    setTimeout(() => {
      if (sliders.current) {
        sliders.current.slickGoTo(0);
      }
    }, 2000);
  }, []);
  return (
    <FlexDiv py={"40px"} flexDirection="column" ref={cardRef}>
      <FlexContainer flexDirection="column" alignItems={"center"}>
        <Heading
          textAlign={"center"}
          variant="heading2"
          color={theme.colors.link2Color}
        >
          All packages
        </Heading>
        <FlexDiv width={"100%"} flexDirection="column">
          <SlideWrap mx={"-10px"}>
            <Slider ref={slider} {...settings}>
              {props?.planData?.length &&
                props?.planData?.map((item, index) => {
                  return (
                    <CardBody
                      flexDirection={"column"}
                      alignItems={"flex-start"}
                      key={index}
                    >
                      <TopBox>
                        <Box>
                          <Typography
                            variant={"title1"}
                            color={theme.colors.white}
                          >
                            {item?.package_duration}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            variant={"title1"}
                            color={theme.colors.white}
                          >
                            {item?.currency_symbol || item?.currency}{" "}
                            {item?.price}
                          </Typography>
                        </Box>
                      </TopBox>
                      <Typography
                        variant="paragraph2"
                        color={theme.colors.white}
                        mb={"21px"}
                      >
                        {
                          <>
                            With this plan you get{" "}
                            <Span>{item?.no_of_consultations}</Span> with your
                            assigned Nutrionist
                          </>
                        }
                      </Typography>
                      <Button
                        variant={"primary1"}
                        bgColor={theme.colors.white}
                        hoverColor={theme.colors.white}
                        TextColor={theme.colors.gray_100}
                        onClick={() => {
                          if (isNutritionPage) {
                            const { package_duration, slug } = item;
                            pageRedirectAdsetGenerator(
                              package_duration,
                              slug,
                              (adsetName) => {
                                window.location.href = `/nutrition-packages/?${adsetName}`;
                              }
                            );
                          } else {
                            return props?.openPaymentPage(item);
                          }
                        }}
                        fontSize={"11px"}
                        fontFamily={"var(--font-700)"}
                        btnPadding={"3.4px 24px"}
                      >
                        Pay now
                      </Button>
                    </CardBody>
                  );
                })}
            </Slider>
          </SlideWrap>
        </FlexDiv>
      </FlexContainer>
    </FlexDiv>
  );
};

const pageRedirectAdsetGenerator = (packageDuration, slug, callback) => {
  packageDuration = packageDuration
    .toLowerCase()
    .replaceAll("months", "month")
    .replaceAll(" ", "_");

  const adsetName = `adset_name=nutritionpage_redirect_${packageDuration}&default_slug=${slug}`;
  callback(adsetName);
};

export default CardComponent;
const Heading = styled(Typography)`
  margin-bottom: 25px;
`;
const CardBody = styled(FlexDiv)`
  background-color: ${theme.colors.cardFallbackBg};
  background-image: ${theme.colors.cardGradient};
  border-radius: 10px;
  padding: 30px;
  outline: 0;
`;
const TopBox = styled(Box)`
  position: relative;
  padding-bottom: 15px;
  margin-bottom: 10px;
  &:after {
    content: "";
    position: absolute;
    left: 0;
    height: 5px;
    border-radius: 10px;
    background-color: ${theme.colors.white};
    width: 30px;
    bottom: 0;
  }
`;
const Span = styled.span`
  color: ${theme.colors.yellow2};
  font-family: var(--font-700);
`;
const SlideWrap = styled(FlexDiv)`
  .slick-slider {
    width: 100%;
    .slick-dots {
      li {
        &.slick-active {
          button {
            &::before {
              background-color: ${theme.colors.dotsColor};
            }
          }
        }
        button {
          position: relative;
          &::before {
            background-color: rgba(92, 92, 110, 0.2);
            border-radius: 50%;
            height: 8px;
            width: 8px;
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: all 0.3s ease-in-out;
          }
        }
      }
    }
    .slick-slide {
      & > div {
        margin: 0 4.5px;
        padding: 15px 7.5px;
        @media only screen and (max-width: 767px) {
          margin: 0;
          padding: 15px;
        }
        @media only screen and (max-width: 767px) {
          padding: 15px 10px;
        }
      }
    }
  }
`;
